import authModule from './auth'
import usersModule from './users'
import messageModule from './message'
import signalrModule from './signalr'
import staffModule from './staff'
import candidateModule from './candidate'
import notificationModule from './notification'
import clientModule from './client'
import financeModule from './finance'
import subBubbleAgreementModule from './subBubbleAgreement'
import locationRestrictionModule from './locationRestriction'
import releasesModule from './releases'
import disputesModule from './disputes'
import commentsModule from './comments'

import formsModule from './forms'
import orgTreeModule from './orgTree'
export default {
  orgTree: orgTreeModule,
  forms: formsModule,
  locationRestriction: locationRestrictionModule,
  notification: notificationModule,
  auth: authModule,
  users: usersModule,
  message: messageModule,
  signalr: signalrModule,
  staff: staffModule,
  candidate: candidateModule,
  client: clientModule,
  finance: financeModule,
  subBubbleAgreement: subBubbleAgreementModule,
  releases: releasesModule,
  disputes: disputesModule,
  comments: commentsModule,
}
